// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".request-password-wrapper[data-v-1ffb88f8]{position:relative;width:280px;margin:16px auto}.request-password-wrapper .icon[data-v-1ffb88f8]{position:absolute;top:23px;right:23px;pointer-events:none}input#request-password-button[data-v-1ffb88f8]{width:269px;padding:10px 10px}input#request-password-button:disabled ~ .icon[data-v-1ffb88f8]{opacity:0.5}\n", ""]);
// Exports
module.exports = exports;
